export const INS_API_ATTRIBUTION = "ins_api_log_attribution";
export const INS_API_MOBILE_CONFIG = "ins_api_mobileconfig";
export const INS_API_FETCH_USER_INFO_WITH_USERNAME =
  "ins_api_fetch_user_info_with_username";
export const INS_API_FETCH_USER_FEED_WITH_USER_NAME =
  "ins_api_fetch_user_feed_with_username";
export const INS_API_COMMENT_MEDIA_CHECK_OFFENSIVE =
  "ins_api_comment_media_check_offensive";
export const INS_API_VIEW_MEDIA = "ins_api_view_media";
export const INS_API_SET_COMMENT_CONTROL = "ins_api_set_comment_control";
export const INS_API_EDIT_PROFILE_PHOTO_EDIT_PROFILE =
  "ins_api_edit_profile_photo_edit_profile";
export const INS_API_UPLOAD_PHOTO_MEDIA_CONFIGURE =
  "ins_api_upload_photo_media_configure";
export const INS_API_FXCAL_GET_SSO_ACCOUNTS = "ins_api_fxcal_get_sso_accounts";
export const INS_API_EDIT_PROFILE_PHOTO_POST_RUPLOAD =
  "ins_api_edit_profile_photo_post_rupload";
export const INS_API_FXCAL_SSO_LOGIN = "ins_api_fxcal_sso_login";
export const INS_API_FETCH_CHALLENG = "ins_api_fetch_challenge";
export const INS_API_BLOKS_APPS = "ins_api_bloks_apps";

export const INS_API_FETCH_USER_PROFILE = "ins_api_fetch_user_profile";
export const INS_API_LOGIN = "ins_api_login";
export const INS_API_TWO_FACTOR_LOGIN = "ins_api_two_factor_login";
export const INS_API_SEND_TWO_FACTOR_LOGIN_SMS =
  "ins_api_send_two_factor_login_sms";
export const INS_API_FETCH_USER_INFO = "ins_api_fetch_user_info";
export const INS_API_FETCH_USER_FEED = "ins_api_fetch_user_feed";
export const INS_API_FETCH_MEDIA_INFO = "ins_api_fetch_media_info";
export const INS_API_FOLLOW_USER = "ins_api_follow_user";
export const INS_API_LIKE_MEDIA = "ins_api_like_media";
export const INS_API_COMMENT_MEDIA_COMMENT = "ins_api_comment_media_comment";
export const INS_API_SET_ACCOUNT_PUBLIC = "ins_api_set_account_public";
export const INS_API_ENABLE_MEDIA_COMMENTS = "ins_api_enable_media_comments";
export const INS_API_USERS_SEARCH = "ins_api_users_search";
export const INS_API_USER_POST_INFO = "ins_api_user_post_info";
